import { createFileRoute } from '@tanstack/react-router'
import { Rocket } from 'lucide-react'
import { DeploymentsScreen } from '@/screens/govern/SCR-049-deployments'

export const Route = createFileRoute('/_app/govern/deployments')({
  staticData: { screen: { id: 'SCR-049', title: 'Deployments', group: 'Govern', perm: 'deployment.manage', order: 5, description: 'Your data plane, its version and its health.', icon: Rocket } },
  component: DeploymentsScreen,
})
